import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Operations", active: 18, inactive: 28 },
  { name: "Customer Service", active: 10, inactive: 25 },
  { name: "Maintenance", active: 18, inactive: 42 },
  { name: "Admin", active: 10, inactive: 35 },
  { name: "Drivers", active: 13, inactive: 30 },
];

const DepartmentBreakdown = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barSize={100}>
        <CartesianGrid vertical={false} stroke="#E5E7EB" strokeOpacity={0.7} />
        <XAxis dataKey="name" />
        <YAxis ticks={[0, 10, 20, 30, 40, 50]} tick={{ fontWeight: "700" }} />
        <Tooltip />
        <Bar dataKey="active" fill="#3b82f6" stackId="a" name="Active" />
        <Bar dataKey="inactive" fill="#ef4444" stackId="a" name="Inactive" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DepartmentBreakdown;
